export default __webpack_public_path__ + "static/media/UsaBank.935c4e41.svg";